module.exports = __webpack_public_path__ + "img/ibm_smart_camp.88515c53.png";